import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from 'investira.react.components';
import { FilesProcessing, EntidadeShortcut } from '../';

/**
 * Renderiza o componente StatusBar.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {number} props.height - Propriedade `height` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const StatusBar = props => {
  const { height = 32 } = props;
  return (
    <Stack
      id="status-bar"
      flexGrow={1}
      sx={{
        height: `${height}px`
      }}
      direction="row"
      alignItems="center"
      spacing={3}>
      <EntidadeShortcut isLoggedIn={props.isLoggedIn} />
      <Stack flexGrow={1}></Stack>
      <FilesProcessing />
    </Stack>
  );
};

StatusBar.propTypes = {
  height: PropTypes.number
};

export default StatusBar;
